import Question from './index'

export default [{
  path: 'vragen/:question',
  component: Question,
  onEnter: () => {
    document.querySelector('.main-wrapper').style.zIndex = 11
  },
  onLeave: () => {
    document.querySelector('.main-wrapper').style.zIndex = ''
  }
}]
